import { Directive, EventEmitter, ElementRef, Output, Input, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { DomEventService } from '../../services/dom-event.service';

@Directive({
    selector: '[apxOverlayClose]',
    standalone: true
})
export class ApxOverlayCloseOnClickAwayDirective implements OnDestroy {
    private readonly elemRef = inject(ElementRef);
    private readonly appEvtService = inject(DomEventService);

    @Input() remainOpen = false;
    @Input() additionalElementIds: string[] = [];
    @Input() set isComponentOpen(isComponentOpen: boolean) {
        if (isComponentOpen) {
            // only subscribe to the event if the component is open to avoid unecessary checks
            this.createEventSub();
        } else {
            this.removeEventSub();
        }
    }
    @Output() readonly closeComponent = new EventEmitter<void>();

    private eventSub!: Subscription;

    ngOnDestroy(): void {
        this.removeEventSub();
    }

    /**
     * Subscribe to the observable from the event service
     */
    private createEventSub() {
        this.eventSub = this.appEvtService.documentMousedownTarget$.subscribe(target => {
            this.handleOutsideClick(target);
        });
    }

    /**
     * Unsubscribe from the observable from the event service
     */
    private removeEventSub() {
        if (this.eventSub) {
            this.eventSub.unsubscribe();
        }
    }

    /**
     * Perform a check to determine whether the event target is inside the bounds
     * of the element the directive is associated with, or the additional elements
     * specified via ID's
     * @param target
     */
    private handleOutsideClick(target: HTMLElement): void {
        const eventInsideBounds = this.additionalElementIds.some(eleId => document.querySelector(`#${eleId}`)?.contains(target)) || this.elemRef.nativeElement.contains(target);

        if (!eventInsideBounds && !this.remainOpen) {
            this.closeComponent.emit();
        }
    }
}
